import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { Button } from 'react-bootstrap';

const ModalAddComment = ({ setShowCommentModal, showCommentModal, addCommentHandler }) => {

    const handleClose = () => setShowCommentModal(false);
    const [comment, setComment] = useState('');

    const saveCommentHandler = async () => {
        await addCommentHandler(comment);
        setComment('');
    };

    return (
        <Modal show={showCommentModal} onHide={handleClose} size="lg" centered>
            <Modal.Header closeButton>
                <Modal.Title>Додати коментар</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="form-group">
                    <label className='mb-2'>Введіть Коментар</label>
                    <input type="text" className="form-control mb-2" autoComplete="off" value={comment} onChange={e => setComment(e.target.value)} />
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={saveCommentHandler}>Збереги</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ModalAddComment;
